import { PlanName, PlanRenewalType } from '@tribeplatform/gql-client/types'

export const planPrice = (planName: PlanName, renewalType: PlanRenewalType) => {
  switch (planName) {
    case PlanName.ENTERPRISE:
      return 'Contact Us'
    case PlanName.PREMIUM:
      return renewalType === PlanRenewalType.MONTH
        ? '$239 USD / mo'
        : '$199 USD / mo'
    case PlanName.PLUS:
      return renewalType === PlanRenewalType.MONTH
        ? '$59 USD / mo'
        : '$49 USD / mo'
    case PlanName.BASIC:
      return '$0'
    default:
      return ''
  }
}

export const planPriceDetails = (
  planName: PlanName,
  renewalType: PlanRenewalType,
): string => {
  switch (planName) {
    case PlanName.ENTERPRISE:
      return '10 staff seats, chat with us for additional'
    case PlanName.PREMIUM:
      return `5 staff seats, additional at $${
        renewalType === PlanRenewalType.YEAR ? '29' : '34'
      }/mo`
    case PlanName.PLUS:
      return `3 staff seats, additional at $${
        renewalType === PlanRenewalType.YEAR ? '19' : '22'
      }/mo`
    case PlanName.BASIC:
      return '3 staff seats'
    default:
      return ''
  }
}

export const planDescription = (planName: PlanName) => {
  switch (planName) {
    case PlanName.ENTERPRISE:
      return 'For large businesses or those in regulated industries.'
    case PlanName.PREMIUM:
      return 'Administration apps and tools for brands and companies.'
    case PlanName.PLUS:
      return 'Essential apps and tools for small businesses and startups.'
    case PlanName.BASIC:
      return 'Free apps for individuals and small communities.'
    default:
      return ''
  }
}

export const planFeatures = (planName?: PlanName): string[] => {
  switch (planName) {
    case PlanName.ENTERPRISE:
      return [
        'Over 100,000 members',
        'Enterprise-grade security',
        'Data residency',
        'Uptime SLA',
        'Migration assistance',
      ]
    case PlanName.PREMIUM:
      return [
        '100,000 members',
        'Premium apps',
        'Single Sign-On (SSO)',
        'API access',
        'White-label',
        'Customer success manager',
      ]
    case PlanName.PLUS:
      return ['10,000 members', 'Apps', 'Analytics', 'Email and chat support']
    case PlanName.BASIC:
      return [
        '100 members',
        'Unlimited spaces',
        'Apps',
        'Custom domain',
        'Theme customization',
        'Community support',
      ]
    default:
      return []
  }
}

export const isPlanDowngrade = (targetPlan, currentPlan): boolean => {
  const downgrades = {
    [PlanName.ENTERPRISE]: [PlanName.PREMIUM, PlanName.BASIC, PlanName.PLUS],
    [PlanName.PREMIUM]: [PlanName.PLUS, PlanName.BASIC],
    [PlanName.PLUS]: [PlanName.BASIC],
    [PlanName.BASIC]: [],
  }

  return downgrades[currentPlan].includes(targetPlan)
}

export const plans = [
  PlanName.BASIC,
  PlanName.PLUS,
  PlanName.PREMIUM,
  PlanName.ENTERPRISE,
]

export const planSeatsCapacity = (planName?: PlanName): number => {
  switch (planName) {
    case PlanName.ENTERPRISE:
      return 10
    case PlanName.PREMIUM:
      return 5
    case PlanName.PLUS:
      return 3
    case PlanName.BASIC:
      return 3
    default:
      return 3
  }
}
